import { Alert, Button, Chip, Stack } from '@mui/material'
import { AUTOSCHEDULE_QUALITY_TAGS } from '../../constants'

const tagLabel = value => AUTOSCHEDULE_QUALITY_TAGS.find(tag => tag.value === value)?.label || value

const AutoscheduleDayQuality = ({ snapshot, onTag, canTag }) => {
    if (!snapshot) return null

    return (
        <Alert
            severity="info"
            icon={false}
            data-testid="ai-generated-day"
            sx={{ mx: { xs: 1, md: 2 }, mb: 1 }}
            action={
                canTag ? (
                    <Stack direction="row" spacing={1}>
                        {AUTOSCHEDULE_QUALITY_TAGS.map(tag => (
                            <Button
                                key={tag.value}
                                size="small"
                                variant={snapshot.tag === tag.value ? 'contained' : 'outlined'}
                                color={tag.value === 'unreasonable' ? 'error' : 'primary'}
                                onClick={() => onTag(snapshot.id, tag.value)}
                            >
                                {tag.label}
                            </Button>
                        ))}
                    </Stack>
                ) : (
                    snapshot.tag && <Chip size="small" label={tagLabel(snapshot.tag)} />
                )
            }
        >
            この日はAI作成です
        </Alert>
    )
}

export default AutoscheduleDayQuality
